import OrSpinner from "../../../../../Components/Utils/OrSpinner";
import { GetFormulariosController } from "../../../../../Controllers/Geral/Formularios/FormulariosControllers";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import CadastrarEditarFormulario from "../../CadastrarEditarFormulario";

interface IEditarFormularioDadosProps {
    idFormulario: number;
    updateList(): void;
}

export default function EditarFormularioDados(
    props: IEditarFormularioDadosProps
) {
    const {
        loading,
        value: formulario,
        execute: updateFormularioDados,
    } = useAsyncEffect(() => {
        return GetFormulariosController(props.idFormulario);
    }, [props.idFormulario]);

    return (
        <OrSpinner
            loading={loading}
            wrapperLoadingClasses="w-100 d-flex justify-content-center align-items-center"
            loadingColor="primary"
        >
            {formulario ? (
                <CadastrarEditarFormulario
                    formulario={formulario}
                    then={() => {
                        props.updateList();
                        updateFormularioDados();
                    }}
                />
            ) : (
                <div className="text-center text-muted">
                    Erro ao carregar dados do formulário
                </div>
            )}
        </OrSpinner>
    );
}
